import { render, staticRenderFns } from "./relateClassify.vue?vue&type=template&id=2604a1e7&scoped=true&"
import script from "./relateClassify.vue?vue&type=script&lang=js&"
export * from "./relateClassify.vue?vue&type=script&lang=js&"
import style0 from "./relateClassify.vue?vue&type=style&index=0&id=2604a1e7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2604a1e7",
  null
  
)

/* custom blocks */
import block0 from "./relateClassify.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports